import React from 'react';
import Sidebar from '../Home/Sidebar/Sidebar';
import Footer from '../Shared/Footer/Footer';
import Menubar from '../Shared/Menubar/Menubar';
import "./Works.css"
import jamuna1 from "../../images/jamuna-1.PNG";
import jamuna2 from "../../images/jamuna-2.PNG";
import jamuna3 from "../../images/jamuna-3.PNG";
import github from "../../images/github.png";
import live from "../../images/web.png";
import book from "../../images/book-store-1.PNG";
import book2 from "../../images/book-store-2.PNG";
import book3 from "../../images/book-store-3.PNG";
import red from "../../images/red-mountain.jpg";
import red2 from "../../images/red-mountain-2.PNG";
import red3 from "../../images/red-mountain-4.PNG";
import red5 from "../../images/red-mountain-5.PNG";

const Works = () => {
    return (
        <div>
           <div className="row">
                <div className="col-md-1">
                    <Sidebar/>
                </div>
                <div className="col-md-10 row">
                    <Menubar/>
                    <div className="">
                        <div className="mt-3">
                        <span class="textColor fs-2 border-bottom border-info text-capitalize d-block mb-5">My Projects</span>
                        </div>
                            {/* jamuna diagonistic center */}
                        <div className="row justify-content-center mt-4">
                            <div className="col-md-4">
                                <div id="carouselExampleInterval" class="carousel slide shadow-sm mt-4" data-bs-ride="carousel">
                                    <div class="carousel-inner shadow">
                                        <div class="carousel-item active" data-bs-interval="10000">
                                        <img src={jamuna1} class="d-block project-shot" alt="..."/>
                                        </div>
                                        <div class="carousel-item" data-bs-interval="2000">
                                        <img src={jamuna2} class="d-block project-shot" alt="..."/>
                                        </div>
                                        <div class="carousel-item">
                                        <img src={jamuna3} class="d-block project-shot" alt="..."/>
                                        </div>
                                    </div>
                                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="mt-3">                                  
                                    <h4 className="textColor">Jamuna Daigonistic center</h4>
                                    <p className="textColor2">A full-stack responsive Doctor's appointment booking web app. That's also a multipage app where you can pick the date and time and fix an appointment with a doctor.</p>
                                    <a href="https://github.com/rajonahmed749/jamuna-diagonistic-center" target="_blank" rel="noreferrer"><img className="socialMedia m-1" src={github} alt=""/> </a>
                                    <a href="https://jamuna-diagonistic-center.web.app/" target="_blank" rel="noreferrer"><img src={live} className="socialMedia m-1" alt="live"/> </a>
                                    <br/>
                                    <div className="mt-1">
                                        <span className="customButton text-white">React js </span>                       
                                        <span className="customButton text-white">Node js</span>                       
                                        <span className="customButton text-white">MongoDB</span>                       
                                        <span className="customButton text-white">Express js</span> 
                                    </div>                      
                                </div>
                            </div>
                        </div>
                            {/* 2nd project */}
                        <div className="row justify-content-center mt-4">
                            
                            <div className="col-md-5">
                                <div className="mt-4">                                  
                                    <h4 className="textColor">Red Mountain Kids</h4>
                                    <p className="textColor2">It's a kindergarten school website where a parent can admit their child. The user can also see the programs that are offered by the authority. </p>
                                    <a href="https://github.com/rajonahmed749/red-mountain" target="_blank" rel="noreferrer"><img className="socialMedia m-1" src={github} alt=""/> </a>
                                    <a href="https://red-mountain-kids.web.app/" target="_blank" rel="noreferrer"><img src={live} className="socialMedia m-1" alt="live"/> </a>
                                    <br/>
                                    <div className="mt-1">
                                        <span className="customButton text-white">React js </span>                       
                                        <span className="customButton text-white">Node js</span>                       
                                        <span className="customButton text-white">MongoDB</span>                       
                                        <span className="customButton text-white">Express js</span> 
                                    </div>                      
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div id="carouselExampleInterval1" class="carousel slide shadow-sm mt-4" data-bs-ride="carousel">
                            <div class="carousel-inner shadow">
                                <div class="carousel-item active" data-bs-interval="10000">
                                <img src={red} class="d-block project-shot" alt="red"/>
                                </div>
                                <div class="carousel-item" data-bs-interval="2000">
                                <img src={red2} class="d-block project-shot" alt="red"/>
                                </div>
                                <div class="carousel-item">
                                <img src={red3} class="d-block project-shot" alt="red"/>
                                </div>
                                <div class="carousel-item">
                                <img src={red5} class="d-block project-shot" alt="red"/>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval1" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval1" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                            </div>
                            </div>
                        </div>
                         {/* The Boook Store */}
                         <div className="row justify-content-center mt-4">
                            <div className="col-md-4">
                                <div id="carouselExampleInterval3" class="carousel slide shadow-sm mt-4" data-bs-ride="carousel">
                            <div class="carousel-inner shadow">
                                <div class="carousel-item active" data-bs-interval="10000">
                                <img src={book} class="d-block project-shot" alt="..."/>
                                </div>
                                <div class="carousel-item" data-bs-interval="2000">
                                <img src={book2} class="d-block project-shot" alt="..."/>
                                </div>
                                <div class="carousel-item">
                                <img src={book3} class="d-block project-shot" alt="..."/>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval3" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval3" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                            </div>
                            </div>
                            <div className="col-md-5">
                                <div className="mt-4">                                  
                                    <h4 className="textColor">The Book Store</h4>
                                    <p className="textColor2">React-based single-page book store site where a user can pick a book and order that book. Firebase authentication system is used for user login. React-router also used for the protected page</p>
                                    <a href="https://github.com/rajonahmed749/book-store" target="_blank" rel="noreferrer"><img className="socialMedia m-1" src={github} alt=""/> </a>
                                    <a href="https://the-book-store-b0c0b.web.app/" target="_blank" rel="noreferrer"><img src={live} className="socialMedia m-1" alt="live"/> </a>
                                    <br/>
                                    <div className="mt-1">
                                        <span className="customButton text-white">React js </span>                       
                                        <span className="customButton text-white">Node js</span>                       
                                        <span className="customButton text-white">MongoDB</span>                       
                                        <span className="customButton text-white">Express js</span> 
                                    </div>                      
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <Footer/>
                </div>
                <div className="col-md-1">

                </div>
            </div>
            
        </div>
    );
};

export default Works;